export const AREA_OPTIONS: string[] = [
	'GMA',
	'NOL',
	'SOL',
	'VIS',
	'MIN',
	'NATIONWIDE',
];
